import { AirHumidifierOffIcon } from './AirHumidifierOffIcon';

/**
 * author: Michael Irigoyen
 * id 9B86205A-73F4-4DB6-9F2C-73654EDF4D52
 * name air-humidifier-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/air-humidifier-off.svg
 * tags
 * - Home Automation 
 */
export const AirDehumidifierIcon = AirHumidifierOffIcon;
export default AirDehumidifierIcon